<template>
  <div class="contact mb30">
    <!-- <h3 class="mt20 title"><i class="fa fa-phone-square fa-fw" /> Contact Information</h3> -->
    <h3 class="mt20 title">Contact Information</h3>
    <el-divider></el-divider>
    <div>
      <ul style="padding-left: 20px;">
        <li>
          <p>
            <span class="titlesign">Principal Investigator:</span> Cheng Chang, Ph.D.  National Center for Protein Sciences, Beijing
          </p>
          <p>
            <span class="titlesign">Email:</span> changcheng@ncpsb.org.cn
          </p>
        </li>
        <li class="mt25">
          <p>
            <span class="titlesign">Principal Investigator:</span> Xiaowen Wang, Ph.D.  National Center for Protein Sciences, Beijing 
          </p>
          <p>
            <span class="titlesign">Email:</span> wangxiaowen@ncpsb.org.cn
          </p>
        </li>
      </ul>
    </div>
    <!-- <ul style="padding-left: 20px;">
      <li>Principal Investigator: Cheng Chang, Ph.D. National Center for Protein Sciences, Beijing  Email: changcheng@ncpsb.org.cn</li>
      <li>Principal Investigator: Xiaowen Wang, Ph.D. National Center for Protein Sciences, Beijing  Email: wangxiaowen@ncpsb.org.cn</li>
    </ul> -->
    <!-- <h3 class="mt30 title"><i class="fa fa-book fa-fw" /> fa-fwPublication</h3> -->
    <h3 class="mt30 title">Publication</h3>
    <el-divider></el-divider>
    <div class="mt20">
      <!-- “A Protein Association Atlas for Human Tissues.” Nature Biotechnology, Nature Publishing Group, May 12, 2025, 1–2. 
      <div class="linkto mt10">
        <i class="el-icon-link mr5" /><a href="https://doi.org/10.1038/s41587-025-02692-y" target="_blank">https://doi.org/10.1038/s41587-025-02692-y</a>.
      </div> -->
    </div>
    <!-- <h3 class="mt30 title"><i class="fa fa-external-link-square fa-fw" /> External Links</h3> -->
    <h3 class="mt30 title">External Links</h3>
    <el-divider></el-divider>
    <div class="exlinks mt20 flex">
      <img src="@/assets/githublogo.jpg" alt="" class="pointer" style="width: 15%;" @click="handleLinkTo(link1)">
      <img src="@/assets/hublogo.png" alt="" class="ml30 pointer" style="height: auto;width: 15%;" @click="handleLinkTo(link2)">
    </div>
  </div>
</template>

<script>
  import { saveUserSuggest } from '@/api'
  export default {
    name: 'contact',
    data() {
      return {
        link1: 'https://github.com/Lifeomics/SLOT',
        link2: 'https://www.pi-hub.org.cn/'
      }
    },
    created() {
      
    },
    methods: {
      handleLinkTo(param) {
        window.open(param, '_blank');
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .contact {
    background: #ffffff;
    padding: 20px;
    width: 80%;
    margin: auto;
    .title {
      color: #17754a;
    }
    .titlesign {
        font-weight: 700;
      }
    ul li {
      // padding-left: 0.5em;
      text-indent: -0.6em;
      padding: 0px 0px 0px 0.5em;
    }
    .linkto {
      a {
        color: #1b82d1;
      }
    }
    .exlinks {
      width: 100%; /* 占满父容器宽度 */
      height: auto; /* 高度自动计算，保持比例 */
    }
  }
</style>
